import { create } from 'zustand';
import { api } from './api';

export const useStore = create((set, get) => ({
  event: null,
  bands: [],
  gallery: [],
  videos: [],
  settings: null,
  loading: true,
  error: null,

  fetchPublicData: async () => {
    try {
      set({ loading: true, error: null });
      const [event, bands, gallery, videos, settings] = await Promise.all([
        api.public.getEvent(),
        api.public.getBands(),
        api.public.getGallery(),
        api.public.getVideos(),
        api.public.getSettings(),
      ]);
      set({ event, bands, gallery, videos, settings, loading: false });
    } catch (err) {
      console.error('Failed to fetch public data:', err);
      set({ error: err.message, loading: false });
    }
  },
}));
